(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLocaleUpperCase('tr-TR');
  let scheduled = false;

  const ensureDesktopOffers = () => {
    return;
    document.querySelectorAll('.menu-bottom .header__nav-list').forEach((nav) => {
      const directItems = Array.from(nav.children || []);
      let offersItem = directItems.find((item) => {
        const link = item.querySelector(':scope > a, :scope > header-menu-trigger a, :scope > header-menu-trigger .menu-main-link');
        return link && normalize(link.textContent) === 'FIRSATLAR';
      });

      if (!offersItem) {
        offersItem = document.createElement('li');
        offersItem.className = 'nav-item seulab-force-offers seulab-generated-offers';
        offersItem.setAttribute('data-seulab-generated', 'offers');

        const link = document.createElement('a');
        link.className = 'menu-main-link';
        link.href = '/#seulab-firsatlar';
        link.textContent = 'FIRSATLAR';
        offersItem.appendChild(link);
        nav.prepend(offersItem);
      } else {
        offersItem.classList.add('seulab-force-offers');
        const link = Array.from(offersItem.querySelectorAll('a, .menu-main-link')).find((candidate) => normalize(candidate.textContent) === 'FIRSATLAR');
        if (link) {
          link.setAttribute('href', '/#seulab-firsatlar');
          link.classList.add('menu-main-link');
          link.removeAttribute('hidden');
          link.setAttribute('aria-hidden', 'false');
        }
      }

      offersItem.removeAttribute('hidden');
      offersItem.setAttribute('aria-hidden', 'false');
    });
  };

  const wireCommerceLinks = () => {
    document.querySelectorAll('a').forEach((link) => {
      const label = normalize(link.textContent);
      if (label === 'FIRSATLAR') {
        link.setAttribute('href', '/#seulab-firsatlar');
        const item = link.closest('.nav-item');
        if (item) item.classList.add('seulab-force-offers');
      }
      if (label === 'TRENDLER') {
        link.setAttribute('href', '/#seulab-trendler');
      }
    });
    ensureDesktopOffers();
  };

  const scheduleWire = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      wireCommerceLinks();
    });
  };

  const start = () => {
    wireCommerceLinks();

    const headerRoot = document.querySelector('.section-header-header-group') || document.querySelector('header-component');
    if (headerRoot && 'MutationObserver' in window) {
      const observer = new MutationObserver(scheduleWire);
      observer.observe(headerRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }

    window.addEventListener('scroll', scheduleWire, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleWire);
})();
